import { makeStyles } from "@saleor/macaw-ui";

const useStyles = makeStyles(
  theme => ({
    root: {
      "& .MuiPaper-root": {
        minWidth: 675,
        boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.25)",
        borderRadius: 16
      },
      "& .MuiButton-containedSecondary": {
        minWidth: "160px"
      }
    },
    dialogTitle: {
      borderTopLeftRadius: 16,
      borderTopRightRadius: 16,
      padding: "1.6rem 2.4rem",
      background:
        "linear-gradient(90deg, #007E92 0%, #009FB8 50.13%, #00B9A3 100%)",
      "& .MuiTypography-root": {
        color: "#FFFFFF",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
      }
    },
    dialogContent: {
      overflowY: "auto"
    },
    flexCenter: {
      display: "flex",
      alignItems: "center"
    },
    flexEnd: {
      display: "flex",
      justifyContent: "end"
    },
    icon: {
      marginRight: "2.1rem"
    },
    closeIcon: {
      cursor: "pointer",
      "& path": {
        stroke: "#FFFFFF"
      }
    },
    gridBox: {
      margin: 0,
      width: "100%"
    },
    required: {
      color: theme.palette.error.main,
      marginLeft: 1,
      "& :after": {
        content: "*"
      }
    },
    boxSuccess: {
      display: "flex",
      padding: "3.2rem 2.4rem !important",
      flexDirection: "column",
      minHeight: "224px",
      justifyContent: "space-between"
    },
    contentTitle: {
      padding: "0.9rem 2.4rem",
      borderTopRightRadius: 8,
      borderTopLeftRadius: 8,
      background: "#EEEEEE"
    },
    contentEditor: {
      maxHeight: "300px",
      overflow: "auto",
      padding: "2.4rem"
    },
    contentBlock: {
      borderRadius: 8,
      border: `1px solid ${theme.palette.grey[400]}`
    },
    errorBlockContent: {
      border: `2px solid ${theme.palette.error.light}`
    }
  }),
  { name: "ModalOrderSendMail" }
);

export default useStyles;
